export default {
    SIMILARITY: 'similarity',
    ELABORATION: 'elaboration',
    GENERALIZATION: 'generalization',
    CONTRAST: 'contrast',
    TEMPORAL: 'temporal',
    CAUSE: 'cause-effect',
    OTHERS: 'others'
}